import { redirect } from "react-router-dom";
import CheckToken from "../../services/CheckToken";
import checkModules from "../../services/checkModules";

export default async function checkAuthenticated(setCheckLogin) {
  try {
    const isAuthenticated = await CheckToken();

    const verifyModules = window?.config?.REACT_APP_VERIFY_MODULES || "";
    if (verifyModules === "true") {
      await checkModules();
    }

    if (isAuthenticated == false) {
      setCheckLogin(false);
      localStorage.clear();
      return redirect("/login");
    } else {
      setCheckLogin(true);
      return null;
    }
  } catch (e) {
    console.error(e);
  }
}
